import { DiabetesClinicalProtocol, HypertensionClinicalProtocol } from "./ClinicalProtocol.ts";

export type EmrType = "none" | "athena";

export type Organization = {
  id: string;
  name: string;
  emrType: EmrType;
  hypertensionClinicalProtocols: HypertensionClinicalProtocol[];
  diabetesClinicalProtocols: DiabetesClinicalProtocol[];
};

export type OrganizationApiDto = {
  id: string;
  name: string;
  emrType: EmrType;
  hypertensionClinicalProtocols: HypertensionClinicalProtocol[];
  diabetesClinicalProtocols: DiabetesClinicalProtocol[];
};

export const toOrganization = (dto: OrganizationApiDto): Organization => ({
  ...dto,
});
